import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { GetOperatorTitleByIdPipe } from "./pipes/get-operator-title-by-id.pipe";
import { ReportingComponent } from "./reporting.component";
import { ReportingService } from "./reporting.service";

@NgModule({
  declarations: [ReportingComponent, GetOperatorTitleByIdPipe],
  exports: [ReportingComponent],
  imports: [CoreModule, SharedModule],
  providers: [ReportingService],
})
export class ReportingModule {}
